import React, { useState, FormEvent, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, AnchorButton, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, NumericInput, TextArea, Position, Toaster, Intent, MenuItem } from "@blueprintjs/core";
import { Radio, RadioGroup, Switch, Alert, Dialog, Callout, Tooltip} from "@blueprintjs/core";

import { H2, H3, H4, H5, H6 } from "@blueprintjs/core";
import { Classes, Card, Elevation } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";


import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import svgWait2 from './svg/wait2.gif'
import svgcaretdown from './svg/caret-down.svg'

import { SLMastInfo, StkCodeInfo } from './Types'   // 20230327
import { SystemHeader, ClientPicker } from './CommonUI';

import i18next from 'i18next';


interface PageInfo {
    n: number
}

var GsbFlag: any;

var UserID: string;
var PgmCode = "SL002" ;
var isReqAuth2:boolean = false ;
var isReqValueLimitAuth2:boolean = false ;

interface SLmastViewProps {
    gsb: AxiosInstance,
    LocationMast: SLMastInfo,
    LocationMast0: SLMastInfo, 
    baseUrl?: string,
    token?: string | null,
    onPrevRec?: () => void,
    onNew?: () => void,
    onEdit?: () => void,
    onDelete?: () => void,
    onNextRec?: () => void,
    ViewMode: any,
    logKey2: any,
}


function SLmastView({ gsb, LocationMast = {} as SLMastInfo, LocationMast0 = {} as SLMastInfo, baseUrl = "", token = "", onPrevRec = () => { }, onNew = () => { }, onEdit = () => { }, onDelete = () => { }, onNextRec = () => { }, ViewMode, logKey2 }: SLmastViewProps) {

    const { t, i18n } = useTranslation();    
    
    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)
    const [isDeletePress, setisDeletePress] = useState(false)
    const [isCanDelete, setisCanDelete] = useState(true)
    const [isDeletePress2, setisDeletePress2] = useState(false)

    const [AuthUser, setAuthUser] = useState("")
    const [password, setPassword] = useState("")

    const [StkNameValue, setStkNameValue] = useState("")
    
    
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    let logKey3a = logKey2.substr(0,logKey2.indexOf("*")); 
    let logKey3b = logKey2.substr(logKey2.indexOf("*")+1); 
    let logKey3c = logKey3b.substr(logKey3b.indexOf("*")+1); 
    logKey3b = logKey3b.substr(0,logKey3b.indexOf("*")); 
    logKey3c = logKey3c.substr(0,logKey3c.indexOf("*")); 

    

    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastView UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, LocationMast])

    const onReqAuthDelRec = () => {
        (async () => {
            try {
                const res2 = await gsb.post('/PgmAccess', {
                    userId: AuthUser,
                    password: password,
                    cIPAddr: "",
                    cReqUser: GsbFlag.UserID,
                } )
                if (res2.data.ok) {
                    setAuthUser("")
                    setPassword("")

                    const res = await gsb.post('/Master', {
                        sb_data: {
                            userId: AuthUser,
                            password: password,
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "ReqUserGroupAccessReqAuth"
                    })
                    console.log("onReqAuthDelRec res.data.data", res.data.data);
                    if ( res.data.ok && res.data.data[0].d_Can_DeleteMaster == "Y") {
                        onDelete();
                        
                    } else {
                        utils.showWarn("Authorization failed")
                        setisShowAlert2(true)
                        setShowAlert2Msg("Authorization failed")
                    }

                } else {
                    utils.showError(res2.data.message)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res2.data.message)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()

    }

    useEffect(() => {
        (async () => {
            try {
                // get Stk Qty Info
                //console.log("SLmastEdit LocationMast.d_StkNo: ", LocationMast.d_StkNo) 
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "GetStkInfo", cStkNo: LocationMast.d_StkNo})
                //console.log("SLmastEdit GetStkQtyInfo data : ", res.data.data) 
                
                if ( LocationMast.d_StkNo.trim().length > 0 && res.data.count > 0 )
                {
                    setStkNameValue(res.data.data[0].d_StkName)
                } else { 
                    setStkNameValue("")
                }
               
            } catch (error) {
                showErrorBox(error)
            }
        })()

    }, [gsb, LocationMast.d_StkNo])


    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    if (! ("d_StkNo" in LocationMast)) return null


    return (
        <div>
            {/* define add,change,delete button */}
            { ViewMode === "V" && <div className="Row">
                <Button className="Col-1-1" icon="direction-left" onClick={() => onPrevRec()} >Prev</Button>
                
                <Button className="Col-2-1" disabled={isReadOnly} icon="add" onClick={() => onNew() } >New</Button>
                <Button className="Col-3-1" disabled={isReadOnly} icon="edit" onClick={() => onEdit() } >Edit</Button>
                <Button className="Col-4-1" disabled={isReadOnly} icon="delete" onClick={() => setisDeletePress(true) } >Delete</Button>
                    <Alert
                        cancelButtonText="Cancel"
                        confirmButtonText="Delete"
                        canEscapeKeyCancel={true}
                        icon="trash"
                        intent={Intent.DANGER}
                        isOpen={isDeletePress}
                        onCancel={ () => setisDeletePress(false) }
                        onConfirm={ () => { onDelete(); setisDeletePress(false) } }
                    >
                        <p>
                            Are you sure to Delete ?
                        </p>
                    </Alert>
                
                <Button className="Col-5-1" icon="direction-right" onClick={() => onNextRec()} >Next</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }
            </div> }
            { ViewMode === "L" && <div>
                Stock : {LocationMast.d_StkNo}, {LocationMast.d_Location} 
                { (logKey2.indexOf("*A1") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Amend</div> }
                { (logKey2.indexOf("*C") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Create</div> }
                { (logKey2.indexOf("*D") > 0 ) && <div id="DispText2">Action : {logKey3a} {logKey3b} User {logKey3c} Delete</div> }
                { ! (LocationMast0.d_AuthId.toString() == "") && <div id="DispText2">Auth : {utils.dispDate(LocationMast0.d_AuthDate, "3")} {LocationMast0.d_AuthTime} User {LocationMast0.d_AuthId} </div> }
                <div className="Spacing-V-16" />
            </div> }

            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Stock No." labelFor="inputStkNo">
                    <InputGroup readOnly value={LocationMast.d_StkNo} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationMast0.d_StkNo.toString() == "") && 
                    <div id="DispText2" > {LocationMast0.d_StkNo} </div> }
                </FormGroup>
                <FormGroup className="Col-3-5" label="Stock Code / Name" labelFor="inputStkName">
                    <div>
                    <div id="DispText">{LocationMast.d_StkCode}</div>
                    <div id="DispText">{StkNameValue}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Location" labelFor="inputLocation">
                    <InputGroup readOnly value={LocationMast.d_Location} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationMast0.d_Location.toString() == "") && 
                    <div id="DispText2" > {LocationMast0.d_Location} </div> }
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Qty B/F" labelFor="inputBF_Qty">
                    <InputGroup readOnly value={utils.numToString2(LocationMast.d_BF_Qty)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationMast0.d_BF_Qty.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(LocationMast0.d_BF_Qty)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Qty MTD" labelFor="inputMTD_Qty">
                    <InputGroup readOnly value={utils.numToString2(LocationMast.d_MTD_Qty)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationMast0.d_MTD_Qty.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(LocationMast0.d_MTD_Qty)} </div> }
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="CURRENT +/-" labelFor="inputDayQty">
                    <InputGroup readOnly value={utils.numToString2(LocationMast.d_DayQty)} />
                    { ViewMode === "L" && (logKey2.indexOf("*A1") > 0 ) && ! (LocationMast0.d_DayQty.toString() == "") && 
                    <div id="DispText2" > {utils.formatNumber2(LocationMast0.d_DayQty)} </div> }
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            { ViewMode === "V" && <div className="Row">
                <FormGroup className="Col-1-1" label="Balance" labelFor="inputBalanceQty">
                    <InputGroup readOnly value={utils.formatNumber2(LocationMast.d_BF_Qty+LocationMast.d_MTD_Qty+LocationMast.d_DayQty)} />
                </FormGroup>
            </div> }

            <div className="Spacing-V-16"></div>
                <Alert
                    confirmButtonText="OK"
                    icon="tick-circle"
                    intent={Intent.SUCCESS}
                    isOpen={isShowAlert1}
                    onCancel={ () => setisShowAlert1(false) }
                    onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                >
                    <p>
                        {ShowAlert1Msg}
                    </p>
                </Alert>
                <Alert
                    confirmButtonText="OK"
                    icon="cross"
                    intent={Intent.WARNING}
                    isOpen={isShowAlert2}
                    onCancel={ () => setisShowAlert2(false) }
                    onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                >
                    <p>
                        {ShowAlert2Msg}
                    </p>
                </Alert>

        </div>
    )
}

interface SLmastEditProps {
    gsb: AxiosInstance,
    LocationMast?: SLMastInfo,
    isNew?: boolean,
    onSave?: (stk: SLMastInfo) => void,
    onCancel?: () => void;
}

function SLmastEdit({ gsb, LocationMast = {} as SLMastInfo, isNew = false, onSave = () => { }, onCancel = () => { } }: SLmastEditProps) {

    const { register, handleSubmit, reset, setValue, setError, errors } = useForm<SLMastInfo>()
 
    const imgCaretdown = <img className="downIcon" src={svgcaretdown} alt="caretdown" />
    const { t, i18n } = useTranslation();    

    const [isReadOnly, setisReadOnly] = useState(false)
    const [isReqAuth, setisReqAuth] = useState(false)


    const [Caretdown2, setCaretdown2] = useState(false)
    const [StkCodeList, setStkCodeList] = useState([] as StkCodeInfo[])
    const [StkNoValue, setStkNoValue] = useState(LocationMast.d_StkNo)
    const [StkCodeValue, setStkCodeValue] = useState(LocationMast.d_StkCode)
    const [StkNameValue, setStkNameValue] = useState("")


    const [BF_QtyValue, setBF_QtyValue] = useState(utils.numToString2(LocationMast.d_BF_Qty))
    const [MTD_QtyValue, setMTD_QtyValue] = useState(utils.numToString2(LocationMast.d_MTD_Qty))
    const [DayQtyValue, setDayQtyValue] = useState(utils.numToString2(LocationMast.d_DayQty))
    const [BalanceQtyValue, setBalanceQtyValue] = useState(0)

 
    useEffect(() => {
        setisReadOnly(false)
        setisReqAuth(false)
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("ClMastEdit UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            setisReqAuth(true)
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID, LocationMast])

    useEffect(() => {
        (async () => {
            try {
                // get Stock Code List
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "StkCodeList"})
                //console.log("StkCodeList: ", res.data.data) 
                setStkCodeList(res.data.data)
                //console.log("set StkCodeList: ", StkCodeList) 
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])


    useEffect(() => {
        // Call reset to get the values of record SLMastInfo 
        if ("d_StkNo" in LocationMast) {
            reset(LocationMast)
        }
    }, [LocationMast, reset])



    useEffect(() => {
        if ( GsbFlag.Enter2tab == "Y" ) {
            let inputs = utils.PerformEnter2Tab()
        }
    }, [])

    
    useEffect(() => {
        (async () => {
            try {
                // get Stk Qty Info
                //console.log("SLmastEdit LocationMast.d_StkNo: ", LocationMast.d_StkNo) 
                const res = await gsb.post('/Master', {sb_data: "", cPgmId: "Smmast", cAction: "GetStkInfo", cStkNo: StkNoValue})
                //console.log("SLmastEdit GetStkQtyInfo data : ", res.data.data) 
                
                if ( StkNoValue.trim().length > 0 && res.data.count > 0 )
                {
                    setStkCodeValue(res.data.data[0].d_StkCode)
                    setStkNameValue(res.data.data[0].d_StkName)
                } else { 
                    setStkCodeValue("")
                    setStkNameValue("")
                }
               
            } catch (error) {
                showErrorBox(error)
            }
        })()

    }, [gsb, StkNoValue])


    useEffect(() => {
        setBalanceQtyValue(utils.StringToNum2(BF_QtyValue) + utils.StringToNum2(MTD_QtyValue) + utils.StringToNum2(DayQtyValue))
    }, [gsb, BF_QtyValue, MTD_QtyValue, DayQtyValue])


    if (! isNew && ! ("d_StkNo" in LocationMast)) return null


    
    const onSubmit = (data: SLMastInfo) => {

        //console.log("SLmastedit onsubmit data: ", data)
        //console.log("SLmastedit onsubmit StkPrice: ", StkPrice)
        //console.log("SLmastedit onsubmit data.d_StkPrice: ", data.d_StkPrice)

        // put value to json/field before write database dbf

       

        data.d_StkNo = StkNoValue ;

        data.d_BF_Qty = utils.StringToNum2(BF_QtyValue);
        data.d_BF_Qty = utils.StringToNum2(BF_QtyValue);


        data.d_AuthTran = ""
        if (isReqAuth) {
            data.d_AuthTran = "Y"
        }
        
        ;

        (async () => {
            try {
                //console.log("call SLmastedit data", data)
                //console.log("call SLmastedit isNew", isNew)
                const res = await gsb.post('/SLUser', {sb_data: data, cPgmId: "SLmast", cAction: "SLmastValidate", isNew: isNew})
                //console.log("SLmastedit res.data.ok", res.data.ok)
                //console.log("SLmastedit res.data.data", res.data.data)

                if (! res.data.ok) {
                    for (let j = 0; j < res.data.data.length; j++) {
                      
                        setError(res.data.data[j][0], {
                           message: res.data.data[j][1]
                        }); 
                    }

                    return
                }

                onSave(data)

            } catch (error) {
                showErrorBox(error)
            }
        })()

        //onSave(data)
    }



    const StkRenderer: ItemRenderer<StkCodeInfo> = (stk, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${stk.d_StkCode}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={stk.d_StkNo}
                key={stk.d_StkNo}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const StkPredicate: ItemPredicate<StkCodeInfo> = (query, stk, _index, exactMatch) => {
        const normalizedText = `${stk.d_StkNo} - ${stk.d_StkCode}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const StkValueRenderer = (stk: StkCodeInfo) => {
        return stk.d_StkNo
    }



    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            handleSubmit(onSubmit)()
        }
    }

    const handleChang2e = (field: string) => {
        if (field ==="D")
        {
           
        }
        else if (field ==="W")
        {

        }    
       
    }

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }


    return (
        <form onKeyDown={handleHotkey}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>Cancel</Button>
                <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>Save</Button>
                { isReqAuth && 
                    <Callout className="Col-6-2"
                        icon="warning-sign"
                        intent={Intent.WARNING}
                    >
                        Authorization Required
                    </Callout>
                }

             </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                { ! Caretdown2 && 
                    <FormGroup className="Col-1-1" label="Stock No." labelFor="inputStkNo" labelInfo="*">
                        <InputGroup id="inputStkNo" autoFocus disabled={! isNew} value={StkNoValue} defaultValue="" placeholder="Stock No. ..." onChange={utils.handleStringChange(s => setStkNoValue(s)) } inputRef={register({ required: true , maxLength: 6}) } />
                        {errors.d_StkNo && errors.d_StkNo.type === "required" && <span id="Err_msg">Stock No. cannot be Blank</span>}
                        {errors.d_StkNo && errors.d_StkNo.type === "maxLength" && <span id="Err_msg">Max length is 10</span>}
                        {errors.d_StkNo && errors.d_StkNo.types && <span id="Err_msg">{errors.d_StkNo.types.message}</span>}
                    </FormGroup>
                }
                { Caretdown2 && 
                    <FormGroup className="Col3-1-1" label="Stock No." labelFor="inputStkNo" >
                        <Suggest
                            inputProps={{ placeholder: "Please choose Stock No. ..." }}
                            selectedItem={StkCodeList.find((stk1) => stk1.d_StkNo === StkNoValue)}
                            items={StkCodeList}
                            itemRenderer={StkRenderer}
                            itemPredicate={StkPredicate}
                            inputValueRenderer={StkValueRenderer}
                            onItemSelect={(Stk) => { setStkNoValue(Stk.d_StkNo) ; setStkCodeValue(Stk.d_StkCode) ; setStkNameValue(Stk.d_StkName) ; setCaretdown2(!Caretdown2) }}
                        />
                    </FormGroup>
                }
                {/* <span onClick={() => { setCaretdown2(!Caretdown2) } }> {imgCaretdown} </span> */}
                <FormGroup className="Col-3-5" label="Stock Code / Name" labelFor="inputStkName">
                    <div>
                    <div id="DispText">{StkCodeValue}</div>
                    <div id="DispText">{StkNameValue}</div>
                    </div>
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-2" label="Location" labelFor="inputLocation">
                    <InputGroup id="inputLocation" disabled={! isNew} name="d_Location" defaultValue="" placeholder="Location ..." inputRef={register({ maxLength: 8}) } />
                    {errors.d_Location && errors.d_Location.type === "maxLength" && <span id="Err_msg">Max length is 8</span>}
                    {errors.d_Location && errors.d_Location.types && <span id="Err_msg">{errors.d_Location.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Qty B/F" labelFor="inputBF_Qty">
                    <InputGroup className="inputNumberNoSpin" id="inputBF_Qty" autoFocus={! isNew} value={BF_QtyValue} onChange={utils.handleStringChange(n => setBF_QtyValue(n))}  />
                    {errors.d_BF_Qty && errors.d_BF_Qty.type === "min" && <span id="Err_msg">Quantity sholud be greater than 0 </span>}
                    {errors.d_BF_Qty && errors.d_BF_Qty.types && <span id="Err_msg">{errors.d_BF_Qty.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="Qty MTD" labelFor="inputMTD_Qty">
                    {/* <InputGroup className="inputNumberNoSpin" id="inputMTD_Qty" value={MTD_QtyValue} onChange={utils.handleStringChange(n => setMTD_QtyValue(n))}  /> */}
                    <InputGroup readOnly value={MTD_QtyValue} />
                    {errors.d_MTD_Qty && errors.d_MTD_Qty.type === "min" && <span id="Err_msg">Quantity sholud be greater than 0 </span>}
                    {errors.d_MTD_Qty && errors.d_MTD_Qty.types && <span id="Err_msg">{errors.d_MTD_Qty.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label="CURRENT +/-" labelFor="inputDayQty">
                    {/* <InputGroup className="inputNumberNoSpin" id="inputDayQty" value={DayQtyValue} onChange={utils.handleStringChange(n => setDayQtyValue(n))}  /> */}
                    <InputGroup readOnly value={DayQtyValue} />
                    {errors.d_DayQty && errors.d_DayQty.type === "min" && <span id="Err_msg">Quantity sholud be greater than 0 </span>}
                    {errors.d_DayQty && errors.d_DayQty.types && <span id="Err_msg">{errors.d_DayQty.types.message}</span>}
                </FormGroup>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label="Balance" labelFor="inputBalanceQty">
                    <InputGroup readOnly value={utils.numToString2(BalanceQtyValue)} />
                </FormGroup>
            </div>
        </form>
    )
}

interface SLmastMainProps {
    gsb: AxiosInstance
}

const toaster = Toaster.create({
    position: Position.TOP,
})

function SLmastMain({ gsb }: SLmastMainProps) {

    const imgWait = <img className="WaitIcon" src={svgWait2} alt="wait" />
    const coLogo = <img className="coLogo" src="coLogo.gif" alt="Co Logo" />

    let url = document.location.toString()
    let qString = url.substr(url.indexOf("?"))

    let { StkNo: defaultSearchValue = "" }: { StkNo: string } = useParams()

    let logKey = utils.getUrlParameter('logKey', url); 
    let logKey2 = logKey.substr(0,logKey.indexOf("?")); 
    let logviewonly = utils.getUrlParameter('logviewonly', url); 

    const [isReadOnly, setisReadOnly] = useState(false)

    const [data, setData] = useState([] as SLMastInfo[])

    const [searchKey, setSearchKey] = useState("StkNo")
    const [searchValue, setSearchValue] = useState(defaultSearchValue)

    const [showFilters, setShowFilters] = useState(false)
    const [searchAcName, setsearchAcName] = useState("")
    const [searchStkNo, setsearchStkNo] = useState("")
    
    const [nPage, setnPage] = useState(0)
    const [nTotalPage, setnTotalPage] = useState(0)
    const [aPageNumber, setaPageNumber] = useState([] as PageInfo[])
    const [MoblieDev, setMoblieDev] = useState(false)
    const [ShowWait, setShowWait] = useState(false)
    const [searchLimit, setSearchLimit] = useState(50)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [currentLocationMast, setcurrentLocationMast] = useState({} as SLMastInfo)
    const [BlankLocationMast, setBlankLocationMast] = useState({} as SLMastInfo)
    const [CurrentLog1, setCurrentLog1] = useState({} as SLMastInfo)
    const [CurrentLog0, setCurrentLog0] = useState({} as SLMastInfo)
    const [ViewMode, setViewMode] = useState("V")

    const [currentMode, setCurrentMode] = useState("show")
    const [isShowAlert1, setisShowAlert1] = useState(false)
    const [ShowAlert1Msg, setShowAlert1Msg] = useState("")
    const [isShowAlert2, setisShowAlert2] = useState(false)
    const [ShowAlert2Msg, setShowAlert2Msg] = useState("")

    const [CO_NAME, setCO_NAME] = useState("")
    const [companyLogoName, setcompanyLogoName] = useState("")
    const [SBPath, setSBPath] = useState("")
    const [TRAN_DATE, setTRAN_DATE] = useState(utils.formatNumber(new Date()))
    const [SETL_DATE, setSETL_DATE] = useState(utils.formatNumber(new Date()))
    const [cardOpen01, setcardOpen01] = useState("cardOpen01-Theme0")

 
    //gsb default value
    BlankLocationMast.d_StkNo = ""
    BlankLocationMast.d_StkCode = ""
    BlankLocationMast.d_Location = ""
    BlankLocationMast.d_BF_Qty = 0
    BlankLocationMast.d_MTD_Qty = 0
    BlankLocationMast.d_DayQty = 0


    useEffect(() => {
        (async () => {
            try {
                // get GsbFlag from SB.XBS
                const res = await gsb.post('/GsbFlag');
                //console.log("SLmastMain disp user_key: ", res.data.Flag.user_key)
                //console.log("SLmastMain disp MULTI_MKT: ", res.data.Flag.MULTI_MKT)
                //console.log("SLmastMain disp data.Flag: ", res.data.Flag)
                GsbFlag = res.data.Flag;
                //console.log("SLmastMain disp GsbFlag: ", GsbFlag)
                //console.log("SLmastMain disp GsbFlag.lang: ", GsbFlag.lang)
                //console.log("SLmastMain disp GsbFlag.dateFormat: ", GsbFlag.dateFormat)
                console.log("GsbFlag.user_key: ", GsbFlag.user_key)
                //console.log("GsbFlag.UserID: ", GsbFlag.UserID)
                UserID = res.data.Flag.UserID
                //console.log("SLmastMain disp GsbFlag.MULTI_MKT: ", sbFlag.MULTI_MKT)
                //console.log("SLmastMain disp GsbFlag.MGNGP_USER: ", GsbFlag.MGNGP_USER)
                //console.log("SLmastMain disp GsbFlag.CO_NAME: ", GsbFlag.CO_NAME)
                setCO_NAME( GsbFlag.CO_NAME) ;
                setcompanyLogoName( GsbFlag.companyLogoName) ;
                setSBPath( GsbFlag.SBPath) ;
                setTRAN_DATE(GsbFlag.TRAN_DATE ) ;
                setSETL_DATE(GsbFlag.SETL_DATE ) ;
                if ( GsbFlag.isProduction == "Y" ) {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME1);
                } else {
                    setcardOpen01("cardOpen01-Theme"+GsbFlag.DEF_THEME2);
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [gsb])

    useEffect(() => {
        isReqAuth2 = false
        ;
        (async () => {
            try {
                UserID = (typeof UserID === 'string')? UserID.trim() : ''
                if ( UserID.trim().length > 0 ) {
                    const res = await gsb.post('/Master', {
                        sb_data: {
                            d_Userid2: UserID,
                            d_PgmCode: PgmCode
                        }, 
                        cPgmId: "UserPgmAccess", 
                        cAction: "GetUserPgmAccessInfo2"
                    })
                    //console.log("IntRMastMain UserPgmAccess res.data.data", res.data.data)

                    if (res.data.ok) {
                        if ( res.data.data[0].d_PgmAction == "R" ) {
                            setisReadOnly(true)
                        }
                        if ( res.data.data[0].d_PgmAction == "M" || res.data.data[0].d_PgmAction == "C") {
                            isReqAuth2 = true
                        }
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, UserID])



    useEffect(() => {
        if (logviewonly === "Y") {
            setViewMode("L")
        }

        ;
        (async () => {
            try {
                if ( logKey.trim().length > 0 ) {
                    const res = await gsb.post('/SLUser', {
                        sb_data: {
                            d_logKey: logKey,
                        }, 
                        cPgmId: "SLmast", 
                        cAction: "ViewLogRec"
                    })
                    console.log("SLmastMain ViewLogRec res.data.data", res.data.data)

                    if (res.data.ok) {
                        setCurrentLog0(res.data.data[0])
                        setCurrentLog1(res.data.data[1])
                    } else {
                        utils.showWarn(res.data.data)
                    }
                }
            } catch (error) {
                showErrorBox(error)
            }
        })()            
    }, [gsb, logKey])
 


    const PrevRecProcess = async (LocationMast: SLMastInfo) => {
        try {
            //console.log("call PrevRecProcess", LocationMast)
            const res = await gsb.post('/SLUser', {sb_data: LocationMast, cPgmId: "SLmast", cAction: "PrevRec"})
            //console.log("PrevRecProcess show 1: ", stk.d_Seq)
            //console.log("PrevRecProcess data : ", data)
            //console.log("PrevRecProcess res.data : ", res.data.data)
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Location === res.data.data.d_Location) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            //console.log("PrevRecProcess res.data.data : ", res.data.data)
            setcurrentLocationMast(res.data.data)
            //console.log("PrevRecProcess show 2: ", stk.d_StkNo)
            setCurrentMode("show")
            //console.log("PrevRecProcess show 3: ", stk.d_StkNo)
        } catch (error) {
            utils.showError(error)
        }
    }

    const DeleteProcess = async (LocationMast: SLMastInfo) => {
        try {
            LocationMast.d_AuthTran = ""
            if (isReqAuth2) {
                LocationMast.d_AuthTran = "Y"
            }
            //console.log("call DeleteProcess", stk)
            const res = await gsb.post('/SLUser', {sb_data: LocationMast, cPgmId: "SLmast", cAction: "DelRec"})
            if (isReqAuth2) {
                showSuccess("Stock " + LocationMast.d_StkNo +", "+ LocationMast.d_Location + " record deleting, waiting for authorization")
            } else {
                showSuccess("Stock " + LocationMast.d_StkNo +", "+ LocationMast.d_Location  + " record deleted")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Location === res.data.data.d_Location) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentLocationMast(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                setisShowAlert1(true)
                setShowAlert1Msg("Stock " + LocationMast.d_StkNo +", "+ LocationMast.d_Location + " record deleting, waiting for authorization")
            }
        } catch (error) {
            utils.showError(error)
        }
    }

    const NextRecProcess = async (LocationMast: SLMastInfo) => {
        try {
            //console.log("call NextRecProcess", LocationMast)
            const res = await gsb.post('/SLUser', {sb_data: LocationMast, cPgmId: "SLmast", cAction: "NextRec"})
            for (let i = 0; i < data.length; i++) {
                if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Location === res.data.data.d_Location) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setcurrentLocationMast(res.data.data)
            setCurrentMode("show")
        } catch (error) {
            utils.showError(error)
        }
    }

    const newOnSave = async (LocationMast: SLMastInfo) => {
        try {
            //console.log("call newOnSave", LocationMast)
            isReqValueLimitAuth2 =  false
            const res = await gsb.post('/SLUser', {sb_data: LocationMast, cPgmId: "SLmast", cAction: "AddRec"})
            //showSuccess("Seq No. " + LocationMast.d_Seq + " record added")
            if (isReqAuth2) {
                showSuccess("Stock " + LocationMast.d_StkNo +", "+ LocationMast.d_Location + " record adding, waiting for authorization")
            } else {
                showSuccess("Stock " + LocationMast.d_StkNo +", "+ LocationMast.d_Location + " record added")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Location === res.data.data.d_Location) {
                        data[i] = { ...data[i], ...res.data.data }
                        setData(data)
                        break
                    }
                }
            }
            setcurrentLocationMast(res.data.data)
            setCurrentMode("show")
            if (isReqAuth2) {
                //alert("Seq No. " + res.data.data.d_Seq + " record adding, over value limit waiting for authorization")
                setisShowAlert1(true)
                setShowAlert1Msg("Stock " + LocationMast.d_StkNo +", "+ LocationMast.d_Location + " record adding, waiting for authorization")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const editOnSave = async (LocationMast: SLMastInfo) => {
        try {
            //console.log("call editOnSave", LocationMast)
            //console.log("stk.d_CcassStk: ", stk.d_CcassStk)
            isReqValueLimitAuth2 =  false
            const res = await gsb.post('/SLUser', {sb_data: LocationMast, cPgmId: "SLmast", cAction: "UpdateRec"})
            if ( res.data.data.d_Auth_Value_Limit_tran === "Y" ) {
                isReqValueLimitAuth2 =  true
            }
            if (isReqAuth2) {
                showSuccess("Stock " + LocationMast.d_StkNo +", "+ LocationMast.d_Location + " record saving, waiting for authorization")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Location === res.data.data.d_Location) {
                        setcurrentLocationMast(data[i])
                        break
                    }
                }
                setCurrentMode("show")
                //alert("Seq No. " + LocationMast.d_Seq + " record saving, over value limit waiting for authorization")
                setisShowAlert1(true)
                setShowAlert1Msg("Stock " + LocationMast.d_StkNo +", "+ LocationMast.d_Location + " record saving, waiting for authorization")
            } else {
                showSuccess("Stock " + LocationMast.d_StkNo +", "+ LocationMast.d_Location + " record saved")
                for (let i = 0; i < data.length; i++) {
                    if (data[i].d_StkNo === res.data.data.d_StkNo && data[i].d_Location === res.data.data.d_Location) {
                        data[i] = { ...data[i], ...res.data.data }
                        //console.log("editOnSave data", i, data)
                        setData(data)
                        //setCurrentStk(stk)
                        break
                    }
                }   
                //console.log("editOnSave stk", stk)
                //console.log("editOnSave res.data.data", res.data.data)
                setcurrentLocationMast(res.data.data)
                setCurrentMode("show")
            }
        } catch (error) {
            //utils.showError(error)
            showErrorBox(error)
        }
    }

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()

        setShowWait(true)
        setnPage(1)
        let m_limit = searchLimit
        if ( selectedTabId === "detail" ) {
            m_limit = 1
        }

        if ( utils.getDeviceType()) {
            setMoblieDev(true)
        } else {
            setMoblieDev(false)
        }
        
        // get SLmast list if StkNo have value
        try {
            //console.log("SLmastMain onsubmit called", data)
            if ( m_limit > 1 ) {
                const res = await gsb.post('/SLUser',
                {   sb_data: {
                        by: searchKey,
                        start: searchValue,
                        nPage: 1,
                        limit: m_limit,
                        backward: searchBackward,
                        filters: {
                            AcName: searchAcName,
                            StkNo: searchStkNo,
                        }, 
                    },
                    cPgmId: "SLmast",
                    cAction: "ListRec",
                });

                //console.log("onSubmit res.data.data", res.data.data)
                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentLocationMast(res.data.data[0])
                }
                
                if ( res.data.count > 0 ) {
                    const aPageNumber1 = []
                    if ( res.data.count > 0 ) {
                        setnTotalPage(Math.ceil(res.data.count / searchLimit))
                        for ( let j = 1; j <= Math.ceil(res.data.count / searchLimit); j++ ) {
                            aPageNumber1.push({n: j});
                        }
                        setaPageNumber(aPageNumber1)
                    }
                }
    
            } else {
                const res = await gsb.post('/SLUser',
                {   sb_data: {
                        StkNo: searchValue,
                        nPage: 1,
                        limit: m_limit,
                    },
                    cPgmId: "SLmast",
                    cAction: "GetRec",
                });

                if ( res.data.ok ) {
                    //console.log("GetRec res.data.data", res.data.data)
                    setcurrentLocationMast(res.data.data)
                    setCurrentMode("show")
                } else {
                    //alert(res.data.data)
                    setisShowAlert2(true)
                    setShowAlert2Msg(res.data.data)
                }
            }

            setShowWait(false)
        } catch (error) {
            setShowWait(false)
            utils.showError(error)
        }
    }

    // get one SLmast record if StkNo have value
    useEffect(() => {
        if (defaultSearchValue.length > 0) {
            // console.log("calling API for URL param");

            setShowWait(true)
            setnPage(1)
            if ( nPage > 0 ) {
                //setcPrintMode("PS")
            } 
    
            (async () => {
                //console.log("SLmastMain useEffect length > 0  called", data)
                const res = await gsb.post('/SLUser',
                    {   sb_data: {
                            by: "StkNo",
                            start: defaultSearchValue,
                            nPage: 1,
                            limit: 1,
                        },
                        cPgmId: "SLmast",
                        cAction: "ListRec",
                    });

                setData(res.data.data)
                if (res.data.data.length > 0) {
                    setcurrentLocationMast(res.data.data[0])
                }
                setShowWait(false)
            })()
        }
    }, [gsb, defaultSearchValue])

    //Press page No 1 2 3 4
    useEffect(() => {
        if ( nPage > 0 && nPage <= nTotalPage && selectedTabId == "list" ) {
    
            setShowWait(true)
            if ( nPage > 0 ) {
                //setcPrintMode("S")
            } 
    
            (async () => {
                try {
                    //console.log("IntRMastMain useEffect nPage > 0  ", nPage)
                    const res = await gsb.post('/SLUser',
                    {   sb_data: {
                            by: searchKey,
                            start: searchValue,
                            nPage: nPage,
                            limit: searchLimit,
                            backward: searchBackward,
                            filters: {
                                AcName: searchAcName,
                                StkNo: searchStkNo,
                            }, 
                        },
                        cPgmId: "SLmast",
                        cAction: "ListRec",
                    });

                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setcurrentLocationMast(res.data.data[0])
                    }
                    setShowWait(false)
        
                } catch (error) {
                    utils.showError(error)
                }
            })()
        }
    }, [gsb, nPage, selectedTabId])
    

    const showErrorBox = (err: any) => {
        alert("Error:"+err.response.data.subSystem+" - "+err.response.data.description+", OS code:"+err.response.data.osCode)
    }

    const showError = (err: any) => {
        if (err.response) {
            toaster.show({ message: err.response.data.description, intent: Intent.WARNING })
        } else if (err.request) {
            toaster.show({ message: "Request failed", intent: Intent.WARNING })
        } else {
            toaster.show({ message: err.message, intent: Intent.WARNING })
        }
    }

    const showSuccess = (message: string) => {
        toaster.show({ message: message, intent: Intent.SUCCESS })
    }


    // currentMode = show
    let detail = <SLmastView gsb={gsb} LocationMast={currentLocationMast} LocationMast0={currentLocationMast} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentLocationMast)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentLocationMast)} onNextRec={() => NextRecProcess(currentLocationMast)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></SLmastView>
    switch (currentMode) {
        case "new":
            //console.log("currentMode = new")
            detail = <SLmastEdit gsb={gsb} LocationMast={BlankLocationMast} isNew onSave={newOnSave} onCancel={() => { setCurrentMode("show"); setSelectedTabId("detail") } } ></SLmastEdit>
            break
        case "edit":
            //console.log("currentMode = edit")
            detail = <SLmastEdit gsb={gsb} LocationMast={currentLocationMast} onSave={editOnSave} onCancel={() => setCurrentMode("show")} ></SLmastEdit>
            break
        }

    let logKeyViewRec = <SLmastView gsb={gsb} LocationMast={CurrentLog1} LocationMast0={CurrentLog0} baseUrl={gsb.defaults.baseURL} token={localStorage.getItem('token')} onPrevRec={() => PrevRecProcess(currentLocationMast)} onNew={() => setCurrentMode("new")} onEdit={() => setCurrentMode("edit")} onDelete={() => DeleteProcess(currentLocationMast)} onNextRec={() => NextRecProcess(currentLocationMast)} ViewMode={ViewMode} logKey2={logKey2.trim()} ></SLmastView>

    function PageNo(n: number) {
        if (n > 0 ) {
            if ( nPage+n <= nTotalPage ) {
                setnPage(nPage+n)
            }
        } else
        {
            if ( nPage+n > 0 ) {
                setnPage(nPage+n)
            }
        }
        return null;
    }

    let Pagination = <>
        <div className="Row">
            <FormGroup className="Col-1-12" label="">
                Page
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(-1)}>&laquo;</Button>
                }
                { (nTotalPage > 1) && (nPage != 1) && 
                    <Button minimal onClick={() => setnPage(1)}>{1}</Button>
                }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage-10) && (j+1 < nPage) && (j+1 != 1) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage >= 1) && <Button intent='primary'>{nPage}</Button> }
                {aPageNumber.map((no, j) => 
                    (j+1 > nPage) && (j+1 < nPage+10) && (j+1 != nTotalPage) && <Button minimal onClick={() => setnPage(no.n)}>{no.n}</Button>
                )}
                { (nTotalPage > 1) && (nPage != nTotalPage) && 
                    <Button minimal onClick={() => setnPage(nTotalPage)}>{nTotalPage}</Button>
                }
                { (nTotalPage > 1) &&
                    <Button minimal onClick={() =>PageNo(+1)}>&raquo;</Button>
                }
            </FormGroup>
        </div>
    </>


    
    let list = <>
        <div className="Row">
            <Button className="Col-1-1" disabled={isReadOnly} icon="add" onClick={() => { setCurrentMode("new"); setSelectedTabId("detail") }}>New</Button>
        </div>
        <div className="Spacing-V-16" />
        {ShowWait && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
        {/* display search list */}
        <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-StkNo">Stock No</th>
                <th className="TCol-StkCode">Stock Code</th>
                <th className="TCol-Location">Location</th>
                <th className="TCol-Qty">Qty B/F </th>
                <th className="TCol-Qty">Qty MTD </th>
                <th className="TCol-Qty">Qty Day </th>
                <th className="TCol-Qty">Qty Balance </th>
            </thead>
            <tbody id="ma_tr">
                {data.map((LocationMast, i) =>
                    <tr key={i} onDoubleClick={() => { setSelectedTabId("detail") }}>
                        <td className="TCol-StkNo" onClick={() => { setcurrentLocationMast(LocationMast) ; MoblieDev && setSelectedTabId("detail") }}>{LocationMast.d_StkNo}</td>
                        <td className="TCol-StkCode" onClick={() => { setcurrentLocationMast(LocationMast) ; MoblieDev && setSelectedTabId("detail") }}>{LocationMast.d_StkCode}</td>
                        <td className="TCol-Location" onClick={() => { setcurrentLocationMast(LocationMast) ; MoblieDev && setSelectedTabId("detail") }}>{LocationMast.d_Location}</td>
                        <td className="TCol-Qty" onClick={() => { setcurrentLocationMast(LocationMast) }}>{utils.formatNumber2(LocationMast.d_BF_Qty)}</td>
                        <td className="TCol-Qty" onClick={() => { setcurrentLocationMast(LocationMast) }}>{utils.formatNumber2(LocationMast.d_MTD_Qty)}</td>
                        <td className="TCol-Qty" onClick={() => { setcurrentLocationMast(LocationMast) }}>{utils.formatNumber2(LocationMast.d_DayQty)}</td>
                        <td className="TCol-Qty" onClick={() => { setcurrentLocationMast(LocationMast) }}>{utils.formatNumber2(LocationMast.d_BF_Qty+LocationMast.d_MTD_Qty+LocationMast.d_DayQty)}</td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
        {ShowWait && nTotalPage > 0 && <div>{imgWait}</div> }
        {nPage > 0 && Pagination}
    </>

    let CoHead = <SystemHeader companyLogo={companyLogoName} companyName={CO_NAME} dataPath={SBPath} tradeDate={TRAN_DATE} settlementDate={SETL_DATE}></SystemHeader>

    return (
        <>

            <form onSubmit={onSubmit}>
                <div className="Spacing-V-Menu"></div>                
                <div className="Row">
                    <FormGroup className="Col-1-12"  >
                        {CoHead}
                    </FormGroup>
                </div>
                { ! ( logviewonly === "Y" ) && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Stock Location Entry</H3>
                    <div className="Spacing-V-16" />
                    <div className="Row">
                        {/* define search key */}
                        <FormGroup className="Col-1-5" label="Search for Stock Location " labelFor="inputSearchValue">
                            <ControlGroup fill>
                                <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                    <option value="StkNo">Stock No</option>
                                    <option value="Location">Location Code.</option>
                                </HTMLSelect>
                                <InputGroup
                                    id="inputSearchValue"
                                    placeholder="Search"
                                    value={searchValue}
                                    onChange={utils.handleStringChange(s => setSearchValue(s))}
                                    leftIcon="search"
                                    rightElement={<Button icon={IconNames.ARROW_RIGHT} disabled={(selectedTabId === "detail" && ! (searchKey == "StkNo"))} minimal type="submit"></Button>}
                                />
                            </ControlGroup>
                        </FormGroup>
                        <Button className="Col-6-1 Button-LabeledFormGroup" icon="search" disabled={(selectedTabId === "detail" && ! (searchKey == "StkNo"))} type="submit" >{(selectedTabId === "detail") ? "Search" : "List"}</Button>
                        {/* <Button className="Col-7-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button> */}
                        </div>
                    <Collapse isOpen={showFilters}>
                        <div className="Row">
                            {/* define search filter */}
                            {/* <FormGroup className="Col-3-1" label="Stock No." labelFor="searchStkNo">
                                <InputGroup id="searchStkNo" value={searchStkNo} onChange={utils.handleStringChange(s => setsearchStkNo(s))} />
                            </FormGroup> */}
                            {/* <FormGroup className="Col-6-2" label="No. of record(s) to List" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup> */}
                        </div>
                    </Collapse>
                    <Tabs onChange={(newTabId) => setSelectedTabId(newTabId as string)} selectedTabId={selectedTabId}>
                        <Tab id="list" title="List" panel={list} />
                        <Tab id="detail" title="Detail" panel={detail} />
                    </Tabs>
                </Card> }
                {ViewMode === "L" && <Card className={cardOpen01} interactive={false} elevation={Elevation.THREE} >
                    <H3>Stock Location Log View</H3>
                    <div className="Spacing-V-16" />
                    {logKeyViewRec}
                </Card> }

                <div className="Spacing-V-16"></div>
                    <Alert
                        confirmButtonText="OK"
                        icon="tick-circle"
                        intent={Intent.SUCCESS}
                        isOpen={isShowAlert1}
                        onCancel={ () => setisShowAlert1(false) }
                        onConfirm={ () => { setShowAlert1Msg(""); setisShowAlert1(false) } }
                    >
                        <p>
                            {ShowAlert1Msg}
                        </p>
                    </Alert>
                    <Alert
                        confirmButtonText="OK"
                        icon="cross"
                        intent={Intent.WARNING}
                        isOpen={isShowAlert2}
                        onCancel={ () => setisShowAlert2(false) }
                        onConfirm={ () => { setShowAlert2Msg(""); setisShowAlert2(false) } }
                    >
                        <p>
                            {ShowAlert2Msg}
                        </p>
                    </Alert>
            </form>
        </>
    );
}

export default SLmastMain